import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Paper, Typography, Avatar } from '@mui/material';
import { AvatarGroup } from '@mui/material';
import { useTranslation } from "react-i18next";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import SubjectIcon from '@mui/icons-material/Subject';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import MessageIcon from '@mui/icons-material/Message';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import "../../css/main.css";
import '../../css/views/ProjectPage.css';
import { getTextColor } from '../../utils/ColorUtils.jsx'
import ScrollAwareTooltip from 'components/Custom/ScrollAwareTooltip';

export default function ArchiveTaskModal({ myTask, myBoardLabels, getColorForTask, openArchiveTaskModal, formatDate, workspaceWorkers, handleArchiveTaskModalClose, handleArchiveTask, avoidMisfire }) {
    const { t } = useTranslation();
    return (
        <Dialog open={openArchiveTaskModal} onClose={handleArchiveTaskModalClose} className="modal-background-color-archived" >
            <DialogTitle >{t("modal.warning")}</DialogTitle>
            <DialogContent className="white-txt-color" >
                <Typography sx={{ mb: 2 }}>{t("modal.archive_task")}</Typography>
                {(myTask.cover_image || myTask.cover_color) && (
                    <Paper
                        className={`list-cover-paper-project-page ${myTask.cover_image ? 'image' : ''}`}
                        sx={{
                            mt: 2,
                            backgroundColor: myTask.cover_color,
                            backgroundImage: myTask.cover_image
                                ? `url(${myTask.cover_image.startsWith('http') ? myTask.cover_image : `${process.env.REACT_APP_BACKEND_URL}${myTask.cover_image}`})`
                                : 'none',
                        }}
                    />
                )}
                <Paper
                    elevation={4}
                    className={`task-paper-project-page dragging-task-paper-project-page ${myTask.cover_image || myTask.cover_color ? 'cover' : ''} background-archive-task-card`}
                    sx={{
                        borderRadius: '8px',
                        padding: '16px',
                        mt: 2,
                    }}
                >
                    <div className="flex-project-page">
                        {myBoardLabels && myTask?.label?.map((labelId, index) => {
                            const fullLabel = myBoardLabels.find(label => label.id === labelId);

                            if (fullLabel) {
                                return (
                                    <div
                                        key={index}
                                        className={`label-style-project-page ${fullLabel.color === "rainbow" ? 'rainbow' : ''}`}
                                        style={{ backgroundColor: fullLabel.color }}
                                    >
                                        <Typography
                                            className={`label-title-project-page ${fullLabel.color === "rainbow" ? 'no-shadow' : 'with-shadow'}`}
                                            sx={{ color: getTextColor(fullLabel.color) }}
                                        >
                                            {fullLabel.title}
                                        </Typography>
                                    </div>
                                );
                            }
                            return null;
                        })}
                    </div>

                    <div className="task-title-project-page">
                        <Typography sx={{ color: "black" }} variant="h6">
                            <b>#{myTask?.frontend_order}</b> - {myTask?.title}
                        </Typography>
                    </div>

                    <div className="dragging-task-dates-project-page">
                        {(myTask?.start_date || myTask?.due_date || myTask?.end_date) && (
                            <ScrollAwareTooltip title={getColorForTask(myTask).tooltip} arrow>
                                <div className="dragging-task-tooltip-project-page">
                                    <div
                                        className="dragging-task-tooltip-content-project-page"
                                        style={{
                                            backgroundColor: getColorForTask(myTask).backgroundColor,
                                            color: getColorForTask(myTask).color,
                                        }}
                                    >
                                        <AccessTimeIcon className="access-time-icon-project-page" />
                                        {myTask?.end_date
                                            ? formatDate(myTask?.end_date)
                                            : myTask?.due_date
                                                ? formatDate(myTask?.due_date)
                                                : myTask?.start_date
                                                    ? formatDate(myTask?.start_date)
                                                    : ''}
                                    </div>
                                </div>
                            </ScrollAwareTooltip>
                        )}
                        {myTask?.has_description && (
                            <ScrollAwareTooltip title={t('project_page.task_desc')} arrow>
                                <SubjectIcon />
                            </ScrollAwareTooltip>
                        )}
                        {myTask?.has_attachments && (
                            <ScrollAwareTooltip title={t('project_page.task_files')} arrow>
                                <AttachFileIcon />
                            </ScrollAwareTooltip>
                        )}
                        {myTask?.checklist_completion && myTask?.checklist_completion.total > 0 && (
                            <ScrollAwareTooltip title={t("project_page.checklist")} arrow>
                                <div className="checkbox-div-project-page">
                                    <CheckBoxIcon className="checkbox-icon-project-page" />
                                    <Typography variant="body2" className="checkbox-text-project-page">
                                        {`${myTask?.checklist_completion.completed}/${myTask?.checklist_completion.total}`}
                                    </Typography>
                                </div>
                            </ScrollAwareTooltip>
                        )}
                        {myTask.has_comments && (
                            <ScrollAwareTooltip title={t('project_page.comments')} arrow>
                                <div className="checkbox-div-project-page">
                                    <MessageIcon className="message-icon-project-page" />
                                </div>
                            </ScrollAwareTooltip>
                        )}
                        <div className="members-avatar-div-project-page">
                            <AvatarGroup
                                max={4}
                                className="members-avatar-group-project-page"
                            >
                                {myTask?.members?.map((memberId, index) => {
                                    const fullMember = workspaceWorkers?.find(worker => worker.id === memberId);

                                    if (fullMember) {
                                        return (
                                            <ScrollAwareTooltip title={fullMember.full_name || fullMember.username} arrow key={fullMember.id}>
                                                <Avatar
                                                    className="members-avatar-project-page"
                                                    src={`${fullMember.image}`}
                                                />
                                            </ScrollAwareTooltip>
                                        );
                                    }
                                    return null;
                                })}
                            </AvatarGroup>
                        </div>
                    </div>
                </Paper>
            </DialogContent>
            <DialogActions >
                <Button onClick={handleArchiveTaskModalClose} className="decline-button">
                    {t("global.cancel")}
                </Button>
                <Button onClick={handleArchiveTask} disabled={avoidMisfire} className="accept-button">
                    {t("modal.archive")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
